import groq from "groq";

const clientTimeOffsetHours = new Date().getTimezoneOffset() / -60;
export const clientTimeZone = `+${clientTimeOffsetHours.toString().padStart(2, "0")}:00`;

// The groq function dateTime() expects a certain ISO format //TODO, kan denne fjernes nå..?
export const groqDateTime = (dateString: string): string =>
  groq`dateTime(${dateString} + "T00:00:00${clientTimeZone}")`;
